import { Component, OnInit } from '@angular/core';
import  { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { AgregarEventoComponent } from '../agregar-evento/agregar-evento.component';
import { EventosService } from '../../core/eventos.service';
import { Observable } from 'rxjs/Observable';
import { AuthService } from '../../core/auth.service';
import { AngularFireStorage } from 'angularfire2/storage';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-eventos',
  templateUrl: './eventos.component.html',
  styleUrls: ['./eventos.component.css']
})
export class EventosComponent implements OnInit {
  modalOption: NgbModalOptions = {}; // not null!
  eventos: any;
  mostrarVisibles = true;

  maximo = 4;

  // eventos = [
  //   {
  //     nombre: 'Evento de Prueba 1',
  //     fecha: new Date('4/28/18'),
  //     descripcion: 'Lorem Ipsum es simplemente el texto de relleno de las imprentas y archivos de texto.',
  //     lugar: 'Universidad de Antofagasta',

  //   },

  // ];

  constructor(public snackBar: MatSnackBar, private storage: AngularFireStorage, private authService: AuthService, private es: EventosService, private modalService: NgbModal,) { }

  ngOnInit() {
    this.eventos = this.es.getEventosVisibles();

  }


  open() {
    this.modalOption.backdrop = 'static';
    this.modalOption.keyboard = false;
    const modalRef = this.modalService.open(AgregarEventoComponent, this.modalOption);
    // modalRef.componentInstance.id = this.id;
  }

  // eliminar(eventoId:string){
  //   this.es.eliminar(eventoId);
    
  // }

  eliminar(evento: any) {

    evento.fotos.forEach(foto => {
      this.storage.ref(foto.path).delete();
    });

    evento.archivos.forEach(archivo => {
      this.storage.ref(archivo.path).delete();
    });

    this.es.eliminar(evento.id);

    this.snackBar.open('El evento ha sido eliminado correctamente.', 'CERRAR', {
      duration: 4000
    });
  }

  toggleEventos(visibles: boolean) {
    // console.log(visibles);
    if (visibles) {
      this.eventos = this.es.getEventosVisibles();
      this.mostrarVisibles = true;
      this.maximo = 4;

    }
    if (!visibles) {
      this.eventos = this.es.getEventosOcultos();
      this.mostrarVisibles = false;
      this.maximo = 4;
    }
  }

  toggleOculto(oculto: boolean, id: string) {
    // console.log(oculto);
    if (oculto) {
      this.es.actualizar(id,
        {
          oculto: true,
        }
      );
    } if(!oculto) {
      this.es.actualizar(id,
        {
          oculto: false,
        }
      );
    }
  }

  cargarMas() {
    this.maximo += 2;
  }

}



// WEBPACK FOOTER //
// ./src/app/modulos/eventos/eventos.component.ts